<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="title" data-cy="exh-gas-setting-modal-header">
                {{ 'exhaust-settings.add-dialog.title' | translate }}
            </div>

            <div class="buttons-container">
                <div class="button cancel" data-cy="exh-gas-setting-modal-back-button" (click)="cancel()">
                    {{ 'exhaust-settings.add-dialog.cancel' | translate }}
                </div>
                <div class="right-buttons">
                    <div class="button" data-cy="exh-gas-setting-modal-add-one-cylinder-button" (click)="addRows(1)">
                        {{ 'exhaust-settings.add-dialog.single' | translate }}
                    </div>
                    <div class="button" data-cy="exh-gas-setting-modal-add-multi-cylinder-button" (click)="addRows(2)">
                        {{ 'exhaust-settings.add-dialog.multiple' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
